import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const cropPlaningReportList = createAsyncThunk('cropPlaningReportList', async ({ filters, pageable, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'work-farm-crops/all',
            params: {
                farm_id: filters?.farm_id || '',
                crop_id: filters?.crop_id || '',
                status: filters?.status || '',
                from_date: filters?.from_date ? moment(filters.from_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
                to_date: filters?.to_date ? moment(filters.to_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
                pageSize: pageable?.pageSize,
                pageNo: pageable?.currentPage,
                search: pageable?.search || '',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const cropPlaningReportListSlice = createSlice({
    name: 'cropPlaningReportList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(cropPlaningReportList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(cropPlaningReportList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default cropPlaningReportListSlice.reducer;
